import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { App } from './App';
import AdminErrorBoundary from './components/ErrorBoundary';
import './index.css';

// ─── Sentry Init for Admin Panel ────────────────────────────────
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE || 'production',
    release: (window as any).__SENTRY_RELEASE__ || `fahryo-admin@${(window as any).__APP_VERSION__ || 'unknown'}`,

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],

    // Performance: Sample 20% of admin traffic (lower volume than app)
    tracesSampleRate: 0.2,

    // Session Replay: 0% normal, 100% on errors
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,

    // Tag all events as admin
    initialScope: {
      tags: { app: 'admin', feature_area: 'admin_panel' },
    },

    // PII: strip emails from error messages
    beforeSend(event) {
      if (event.exception?.values) {
        for (const v of event.exception.values) {
          if (v.value) {
            v.value = v.value.replace(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g, '[EMAIL]');
          }
        }
      }
      return event;
    },
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AdminErrorBoundary>
      <App />
    </AdminErrorBoundary>
  </React.StrictMode>
);
